import React from "react";
import { useSiteContent } from "../data/content";

export default function TechFocus() {
  const content = useSiteContent();
  const { tech, images } = content;
  return (
    <section id="fokus" className="py-24 lg:py-32 bg-[#0B1F3A] relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />
      <div className="absolute -top-40 -right-32 w-[600px] h-[600px] bg-teal-500/20 blur-[140px] rounded-full" />
      <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] bg-blue-500/10 blur-[140px] rounded-full" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6">
          <span className="text-[12px] font-medium tracking-[0.2em] uppercase text-teal-300">
            {tech.eyebrow}
          </span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-semibold tracking-[-0.02em] text-white leading-[1.1]">
            {tech.title}
          </h2>
          <p className="mt-6 text-slate-300 text-[17px] leading-relaxed max-w-xl">
            {content.ui.tech.lead}
          </p>
          <div className="mt-10 flex flex-wrap gap-2.5">
            {tech.items.map((t) => (
              <span
                key={t}
                className="px-4 py-2 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-sm text-slate-100 backdrop-blur-sm transition-colors duration-200"
              >
                {t}
              </span>
            ))}
          </div>
        </div>
        <div className="lg:col-span-6 grid grid-cols-2 gap-4">
          <div className="rounded-2xl overflow-hidden ring-1 ring-white/10 aspect-[4/5]">
            <img
              src={images.car}
              alt="Connected Car"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="rounded-2xl overflow-hidden ring-1 ring-white/10 aspect-[4/5] mt-12">
            <img
              src={images.ai}
              alt="AI"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
